export default __webpack_public_path__ + "static/media/16-SparekassenBalling.8b9f9552.png";